const Chat = () => (
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h2 className="text-xl font-bold mb-4">Chat with Us</h2>
    <p>Live chat functionality coming soon!</p>
  </div>
);

export default Chat;
